// extracted by mini-css-extract-plugin
export var workout = "style-module--workout--b29bc";
export var workout__btn = "style-module--workout__btn--69382";
export var workout__container = "style-module--workout__container--e7e97";
export var workout__description = "style-module--workout__description--7d6e8";
export var workout__img = "style-module--workout__img--12dcd";
export var workout__info = "style-module--workout__info--8d6c3";
export var workout__title = "style-module--workout__title--00edb";